export default {
  issue_date: null,
  reference_number: null,
  type: null,
  channel: null,
  supplier: {
  cui: null,
    bank: {
    iban: null,
      name: null,
      currency: null
  },
  name: null,
    address: {
    city: null,
      region: null,
      street: null,
      country: null
  },
  reg_com: null
},
  client: {
  cui: null,
    bank: {
    iban: null,
    name: null,
      currency: null
  },
  name: null,
    address: {
    city: null,
      region: null,
      street: null,
      country: null
  },
  reg_com: null
},
  total_value: null,
  net_value: null,
  vat_value: null,
  vat_percentage: null,
  currency: null,
  exchange_rate: null,
  due_dates: [],
  comments: null,
  created_at: null,
  updated_at: null,
  files: [],
  invoices: [],
  contracts: [],
  reservations: [],
  transactions: []
}